namespace TR {

    export class HolidayDealsGrouped {

        find: (any) => ng.IPromise<string>;

        constructor(
            private $http: ng.IHttpService,
            private $location: ng.ILocationService,
            private $filter: any,
            private $q: ng.IQService,
            private dateUtil: any,
            private resourceService: Core.ResourceService,
            private imageService: any,
            private occupancyService: any,
            private fieldGroupService: Core.FieldGroupService,
            private filtering: any,
            private pageStrand: any,
            private tripService: Core.TripService,
            private hotelService: Core.Hotels.HotelService,
            private analytics: any,
            private flightSearch: any,
            private geo: any,
            private holidayDeals: TR.HolidayDeals,
            private preferences: any
        ) {
            this.find = _.memoize(
                options => this._find(options),
                options => angular.toJson(options).replace(/\W/g, '')
            );
        }

        _find({ destinations, dealsPerDestination, startDate,
               duration, occupancy, depAir, flexibility }) {

            if (!destinations || !dealsPerDestination || !startDate
                 || !duration || !occupancy || !depAir) {
               return this.$q.reject();
            }
            let getByDestinationsRequest = {
                Destinations: destinations,
                DealsPerDestination: dealsPerDestination,
                DatesAndDurations: this.getDates(startDate, duration, flexibility),
                DomainId: TRPCONFIG.Domain.DomainId,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                Adults: occupancy[0].Adults,
                ChildAges: occupancy[0].ChildAges || [],
                OriginAirports: depAir,
                DirectFlightsOnly: false,
                DiscountedPricesOnly: true,
                FieldFlags: this.getFieldGroup(),
                SortCriterion: 1,
            };

            return this.$http.post(
                '/api/holidays/deals/getbydestinations',
                getByDestinationsRequest
            )
            .then((res: any) => {
                return res.data;
            })
            .then(dealsForManyDestinations => {
                _.each(dealsForManyDestinations, dealsForADestination => {
                    _.each(dealsForADestination, deal => {
                        this.holidayDeals.enrichHotel(deal, { Duration: duration });
                    });
                });
                return dealsForManyDestinations;
            });
        }

        getDates(StartDate, Duration, Flexibility) {
            let pad = x => {
                x = x + '';
                if (x.length === 1) {
                    x = '0' + x;
                }
                return x;
            };
            let cutOffDate = this.dateUtil.todayPlus(2);

            let dates;
            if (angular.isNumber(Flexibility)) {
                let offsets = _.range(-Flexibility, Flexibility + 1);
                dates = _(offsets).map(offset => this.dateUtil.addDays(StartDate, offset));
            } else {
                let year = StartDate.getFullYear();
                let month = pad(StartDate.getMonth() + 1);
                let endOfMonth = month === '02' ? 29 : 31;
                let days = _.range(1, endOfMonth);
                dates = _(days).map(day => this.dateUtil.parseDate(`${year}-${month}-${pad(day)}`));
            }

            return dates
                .filter(date => date > cutOffDate)
                .map(date => this.dateUtil.serialiseDate(date))
                .map(date => ({
                    Date: date,
                    Duration
                }))
                .value();
        }

        getFieldGroup() {
            return this.fieldGroupService.getFieldGroup(
                Core.FieldType.Global,
                Core.FieldType.Titles,
                Core.FieldType.Url,
                Core.FieldType.Description,
                Core.FieldType.Summary,
                Core.FieldType.HolidayDeals,
                Core.FieldType.LegacyFacilities,
                Core.FieldType.Weather,
                Core.FieldType.Distances,
                Core.FieldType.Recommendations,
                Core.FieldType.Airports,
                Core.FieldType.TransferTimes
            );
        }
    }

    angular
        .module('TR')
        .service('holidayDealsGrouped', HolidayDealsGrouped);
}
